import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-5 px-4 bg-primary text-white" data-id="element-42">
      <div className="max-w-3xl mx-auto" data-id="element-43">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="flex flex-col md:flex-row items-center gap-4 text-center md:text-left" data-id="element-44">
          <div className="flex-shrink-0" data-id="element-45">
            <div className="w-16 h-16 rounded-full bg-white/10 flex items-center justify-center border-2 border-accent/50" data-id="element-46">
              <ShieldCheckIcon className="w-8 h-8 text-accent" data-id="element-47" />
            </div>
          </div>

          <div data-id="element-48">
            <h2 className="text-2xl font-bold mb-2 font-serif" data-id="element-49">
              Probalo durante 7 días sin riesgo
            </h2>
            <p className="text-base text-white/80 leading-relaxed" data-id="element-50">
              Si dentro de los primeros 7 días sentís que este ebook no es para
              vos, podés solicitar la devolución de tu dinero. Quiero que
              compres con total tranquilidad y confianza.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}